'use client';

import { Product } from 'shared/types/product/Product';
import ProductPrice, { ProductPriceProps } from 'components/padi-ui/product-price';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';

const ProductPriceTastic = ({ data }: TasticProps<DataSource<{ product: Product }> & ProductPriceProps>) => {
  if (!data?.data?.dataSource?.product) return null;

  return (
    <ProductPrice
      product={data?.data?.dataSource.product}
      beforeText={data?.beforeText}
      afterText={data?.afterText}
      alignment={data?.alignment}
      fontWeight={data?.fontWeight}
      italic={data?.italic}
    />
  );
};

export default ProductPriceTastic;
